import { baseApi } from "./baseApi";

const VENDORSTAFF_BASE_URL = "/vendor-staffs";

export const vendorVendorStaffApi = baseApi.injectEndpoints({
  tagTypes: ["VendorStaff"],

  endpoints: (builder) => ({
    getVendorStaffList: builder.query({
      query: (params) => ({ url: `${VENDORSTAFF_BASE_URL}`, params }),
      providesTags: (result) =>
        result?.data?.map(({ _id }) => ({ type: "VendorStaff", id: _id })) ?? [
          { type: "VendorStaff", id: "LIST" },
        ]

    }),

    getVendorStaffDDL: builder.query({
      query: (params) => ({ url: `${VENDORSTAFF_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data?.map(({ _id }) => ({ type: "VendorStaff", id: _id })) ?? [
          { type: "VendorStaff", id: "DDL" },
        ]
    }),

    getVendorStaffDetail: builder.query({
      query: (id) => `${VENDORSTAFF_BASE_URL}/${id}`,
      providesTags: (result, error, { _id }) => [
        { type: "VendorStaff", _id },
        { type: "VendorStaff", id: "LIST" },
      ],
    }),

    createVendorStaff: builder.mutation({
      query: (payload) => ({
        url: VENDORSTAFF_BASE_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "VendorStaff", id: "LIST" },
        { type: "VendorStaff", _id },
      ],
    }),

    updateVendorStaff: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;

        return {
          url: `${VENDORSTAFF_BASE_URL}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: "VendorStaff", id },
        { type: "VendorStaff", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetVendorStaffListQuery,
  useLazyGetVendorStaffListQuery,
  useGetVendorStaffDDLQuery,
  useLazyGetVendorStaffDDLQuery,
  useGetVendorStaffDetailQuery,
  useCreateVendorStaffMutation,
  useUpdateVendorStaffMutation,
} = vendorVendorStaffApi;
